import  { Fragment, useEffect, useState } from "react";
import { Container, Form, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { DataBasicForm } from "../../Components/product/DataBasicForm";
import { DataByCountryForm } from "../../Components/product/DataByCountryForm";
import { DataImgForm } from "../../Components/product/DataImgForm";

export const CreateProduct = () => {
  const { postData, patchData, getData, invalidateQuery } = useDataFetch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { control, handleSubmit, setValue, getValues, reset, watch, formState: { errors } } = useForm({
    defaultValues: {
      title: "",
      shortDescription: "",
      longDescription: "",
      category: "",
      images: [],
      aditionalData: [],
      mainImage: null,
    },
  });

  const [imageFiles, setImageFiles] = useState([]);

  const { data: productData, isLoading } = getData(["product", id], `/product/${id}`, {
    enabled: !!id,
  });

  useEffect(() => {
    if (productData?.product) {
      const product = productData.product;
      
      reset({
        title: product.title,
        shortDescription: product.shortDescription,
        longDescription: product.longDescription,
        category: product.category,
        images: product.images ?? [],
        aditionalData: (product.aditionalData ?? []).map((item) => ({
          ...item,
          country_id: item.country_id.id,
        })),
        mainImage: product.mainImage,
      });
      setImageFiles( product.images ?? []);
    }
  }, [productData, reset]);

  const { mutateAsync: createProduct } = postData("/product", {}, {
    onSuccess: () => {
      toast.success("Producto creado exitosamente!");
      invalidateQuery(["product"]);
      navigate("/product");
    },
  });

  const { mutateAsync: updateProduct } = patchData(`/product`, {}, {
    onSuccess: () => {
      toast.success("Producto actualizado exitosamente!");
      navigate("/product");
    },
  });

  const { mutateAsync: uploadImg } = postData("/product/upload/photo", {}, {
    onSuccess: (response,variables) => {;
      const { index, isUpd } = variables;
  
      if (response.message === "photo_uploaded_successfully") {
        const currentImages = getValues("images") || [];
        const updated = [...currentImages];
        updated[index] = response.fileName;

        setValue("images", updated);

        toast.success(
          isUpd ? "Imagen actualizada exitosamente!" : "Imagen subida exitosamente!"
        );
      }
    },
  });

  const handleImageChange = (file, index,isUpdating) => {
    if (!file) return;
    
    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64Obj = {
        file: { name: file.name, base64URL: reader.result },
      };
      await  uploadImg(
      { ...base64Obj, index, isUpd: isUpdating }, 
      { onError: () => toast.error("Error subiendo imagen") }
    );
    };
    reader.readAsDataURL(file);

    const updatedFiles = [...imageFiles];
    updatedFiles[index] = file;
    
    setImageFiles(updatedFiles);
   

  };

  const addImageSlot = () => setImageFiles((prev) => [...prev, null]);

  const removeImageSlot = (index) => {
    const updatedFiles = [...imageFiles];
    updatedFiles.splice(index, 1);
    setImageFiles(updatedFiles);

    const currentImages = getValues("images");
    const updatedImages = [...currentImages];
    updatedImages.splice(index, 1);
    setValue("images", updatedImages);

    if (index == getValues("mainImage")) {

      if (index === 0) {
        setValue("mainImage", 0);
      }else {
        setValue("mainImage", index-1);
      }
     
    }

  };

  const handleRemoveCountry = (index) => {
    const currentData = getValues("aditionalData");
    currentData.splice(index, 1);
    setValue("aditionalData", [...currentData]);
  };

  const setMainImage = (index) => {
    setValue("mainImage", index);
  };

  const cleanCurrency = (value) => {
    if (typeof value === "number") return value;
    if (typeof value === "string") {
      return Number(
        value
          .replace(/\./g, "")
          .replace(/[^0-9,]/g, "")
          .replace(",", ".")
      );
    }
    return 0;
  };

  const onSubmit = async (data) => {
    if (!data.aditionalData || data.aditionalData.length === 0) {
      toast.error("Debe agregar al menos un país con precios antes de guardar el producto.");
      return;
    }

    if (data.images.length === 0) {
      toast.error("Debe subir al menos una imagen del producto.");
      return;
    }

    if (data.mainImage === null) {
      toast.error("Debe seleccionar una imagen principal.");
      return;
    }

    const payload = {
      ...data,
      aditionalData: data.aditionalData.map((d) => ({
        ...d,
        price_local_currency: cleanCurrency(d.price_local_currency),
        price_usdt: cleanCurrency(d.price_usdt),
        delivery_time_days: cleanCurrency(d.delivery_time_days),
        loyalty_points: d.loyalty_points,
        influencer_bonus: d.influencer_bonus,
      })),
    };

    if (id) {
      await updateProduct({ ...payload, id });
    } else {
      await createProduct(payload);
    }
  };

  const pageTitle = id ? "Editar producto" : "Nuevo producto";

  if (id && isLoading) {
    return (
      <div className="text-center mt-5">
        <Spinner color="primary" />
        <p>Cargando producto...</p>
      </div>
    );
  }

  return (
    <Fragment>
      <Container fluid={true} className="ui-content" style={{ padding: 0 }}>
        <button type="button" className="ui-back" onClick={() => navigate(-1)}>
          <i className="ri-arrow-left-line" /> Volver a productos
        </button>
        <h1 className="ui-page-header__title" style={{ marginBottom: 16 }}>{pageTitle}</h1>

        <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="ui-grid-product">
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <DataBasicForm control={control} errors={errors} />
              <DataImgForm
                imageFiles={imageFiles}
                handleImageChange={handleImageChange}
                removeImageSlot={removeImageSlot}
                addImageSlot={addImageSlot}
                mainImage={watch("mainImage")}
                onSelectMainImage={setMainImage}
                imagesFromServer={getValues("images")}
              />
            </div>

            <DataByCountryForm
              aditionalData={watch("aditionalData")}
              setAditionalData={(newList) => setValue("aditionalData", newList)}
              handleRemoveCountry={handleRemoveCountry}
            />
          </div>
        </Form>
      </Container>
    </Fragment>
  );
};
